import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { ThemeProvider } from "./context/ThemeContext.jsx";
import { SidebarProvider } from "./context/SidebarContext.jsx";
import { ToastContainer } from "react-toastify";
import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import muiTheme from "./themes/muiTheme.js";
import { Provider } from "react-redux";
import store from "./redux/store.js";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import ActiveUsersModal from "./components/ActiveUserModal/ActiveUsersModal.jsx";

let persistor = persistStore(store);

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <ThemeProvider>
      <MuiThemeProvider theme={muiTheme}>
        <SidebarProvider>
          {/* <PersistGate persistor={persistor}> */}
          <ActiveUsersModal>
            <App />
          </ActiveUsersModal>
          {/* </PersistGate> */}
          <ToastContainer />
        </SidebarProvider>
      </MuiThemeProvider>
    </ThemeProvider>
  </Provider>
);
